export default __webpack_public_path__ + "static/media/exclametary_info_icon_yellow.f867ab70.svg";